"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KPI_WITH_COMPARISON_SIZE_INFO = exports.KPI_WITHOUT_COMPARISON_SIZE_INFO = exports.GRID_ROW_HEIGHT_IN_PX = void 0;
exports.GRID_ROW_HEIGHT_IN_PX = 20;
exports.KPI_WITHOUT_COMPARISON_SIZE_INFO = {
    width: {
        min: 2,
        default: 2,
    },
    height: {
        default: 8,
        min: 6,
        max: 40,
    },
};
exports.KPI_WITH_COMPARISON_SIZE_INFO = {
    width: {
        min: 2,
        default: 2,
    },
    height: {
        default: 11,
        min: 10,
        max: 40,
    },
};
//# sourceMappingURL=constants.js.map